import React, { PropsWithChildren } from 'react';
import { Paper } from '@mui/material';

export const HelpCenterPaper: React.FC<PropsWithChildren> = ({ children }) => (
  <Paper
    variant="outlined"
    sx={{
      width: '550px',
      height: '750px',
      overflow: 'auto',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: (theme) => theme.shadows[11],
    }}
  >
    {children}
  </Paper>
);
